export interface EloDeltaProps {
  delta: number;
  className?: string;
}

export function EloDelta({ delta, className }: EloDeltaProps) {
  const positive = delta >= 0;
  const text = positive ? `+${delta}` : `${delta}`;
  const colour = positive ? 'text-[oklch(0.55_0.13_150)]' : 'text-[oklch(0.55_0.14_30)]';
  return (
    <span
      className={[
        'font-mono tabular-nums',
        colour,
        className,
      ].filter(Boolean).join(' ')}
    >
      {text}
    </span>
  );
}
